import _ from 'lodash'
import moment from 'moment'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

export function useDateFormat() {
  const { formatDate: intlFormat } = useIntl()

  const formatDate = useCallback<typeof intlFormat>(
    (value, opts) => {
      if (!value) return ''

      let val = value
      if (_.isString(value)) {
        val = moment.utc(value).toISOString(true)
      }

      return intlFormat(val, opts)
    },
    [intlFormat]
  )
  return { formatDate }
}
